module.exports = __webpack_public_path__ + "static/img/szzc3.151aaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szzc3.png
// module id = X1Zq
// module chunks = 73